/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLocationSubscriptionRequest
 */
export interface UpdateLocationSubscriptionRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationSubscriptionRequest
     */
    plan: UpdateLocationSubscriptionRequestPlanEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationSubscriptionRequest
     */
    paymentFrequency: UpdateLocationSubscriptionRequestPaymentFrequencyEnum;
}


/**
 * @export
 */
export const UpdateLocationSubscriptionRequestPlanEnum = {
    Starter: 'starter',
    Growth: 'growth',
    Unlimited: 'unlimited'
} as const;
export type UpdateLocationSubscriptionRequestPlanEnum = typeof UpdateLocationSubscriptionRequestPlanEnum[keyof typeof UpdateLocationSubscriptionRequestPlanEnum];

/**
 * @export
 */
export const UpdateLocationSubscriptionRequestPaymentFrequencyEnum = {
    Monthly: 'monthly',
    Yearly: 'yearly'
} as const;
export type UpdateLocationSubscriptionRequestPaymentFrequencyEnum = typeof UpdateLocationSubscriptionRequestPaymentFrequencyEnum[keyof typeof UpdateLocationSubscriptionRequestPaymentFrequencyEnum];


/**
 * Check if a given object implements the UpdateLocationSubscriptionRequest interface.
 */
export function instanceOfUpdateLocationSubscriptionRequest(value: object): value is UpdateLocationSubscriptionRequest {
    if (!('plan' in value) || value['plan'] === undefined) return false;
    if (!('paymentFrequency' in value) || value['paymentFrequency'] === undefined) return false;
    return true;
}

export function UpdateLocationSubscriptionRequestFromJSON(json: any): UpdateLocationSubscriptionRequest {
    return UpdateLocationSubscriptionRequestFromJSONTyped(json, false);
}

export function UpdateLocationSubscriptionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLocationSubscriptionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'plan': json['plan'],
        'paymentFrequency': json['paymentFrequency'],
    };
}

export function UpdateLocationSubscriptionRequestToJSON(json: any): UpdateLocationSubscriptionRequest {
    return UpdateLocationSubscriptionRequestToJSONTyped(json, false);
}

export function UpdateLocationSubscriptionRequestToJSONTyped(value?: UpdateLocationSubscriptionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan': value['plan'],
        'paymentFrequency': value['paymentFrequency'],
    };
}

